
































import { defineComponent } from '@nuxtjs/composition-api'
import CSubtitleButton from '~/components/shared/configurable/button/CSubtitleButton.vue'
export default defineComponent({
  components: {
    CSubtitleButton
  },
  props: {
    minimumPrice: { type: [String, Number], required: true },
    loading: { type: Boolean, default: false },
    containerClasses: { type: [String, Array], required: false, default: '' }
  }
})
